import { render, staticRenderFns } from "./storagesettings.vue?vue&type=template&id=541d26d1&scoped=true&"
import script from "./storagesettings.vue?vue&type=script&lang=js&"
export * from "./storagesettings.vue?vue&type=script&lang=js&"
import style0 from "./storagesettings.vue?vue&type=style&index=0&id=541d26d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541d26d1",
  null
  
)

export default component.exports